import React, { useEffect, useState } from 'react';
import styled, { keyframes } from 'styled-components';
import { useAppSelector } from '../../store/hooks';
import { obterNomeUsuario, obterIdTenent, ehPlanoGratuito, estaEmPeriodoDeTeste } from '../../services/seguranca';
import avatar from '../../assets/avatar-implantacao.png';
import avatarWhats from '../../assets/whatsapp-avatar.jpg';
import avatarTres from '../../assets/dc5baf8e-795d-46e3-af91-da79d63912fa.png';
import {
  obterStatusTreinamentoPosVenda,
  obterRastroPosVenda,
  responderTreinamentoPosVenda,
  StatusTreinamento,
} from '../../services/treinamento';

const ADMIN_EMPRESA_ID = 'f5ec617c-48b1-4e42-a3e9-c545c974f31a';
const SESSION_ADIADO = 'treinamentoPosVendaAdiado';

const AZUL = '#1F467E';

// Direcionamento por WhatsApp conforme o estágio de pós-venda do cliente no CRM.
const WHATS_SUPORTE = '5585991491356';
const WHATS_POSVENDA = '5585988885089';
const linkWhats = (numero: string, mensagem: string) =>
  `https://wa.me/${numero}?text=${encodeURIComponent(mensagem)}`;

const fadeIn = keyframes`from { opacity: 0; } to { opacity: 1; }`;
const slideUp = keyframes`from { opacity: 0; transform: translateY(16px); } to { opacity: 1; transform: translateY(0); }`;

const Overlay = styled.div`
  position: fixed; inset: 0; z-index: 3000;
  background: rgba(10, 22, 40, 0.6);
  display: flex; align-items: center; justify-content: center;
  padding: 16px; animation: ${fadeIn} 0.2s ease;
`;

const Card = styled.div`
  position: relative; width: 100%; max-width: 420px;
  background: #ffffff; border-radius: 16px; overflow: hidden;
  box-shadow: 0 20px 50px rgba(10, 22, 40, 0.28);
  animation: ${slideUp} 0.3s ease;
`;

const Header = styled.div`
  background: ${AZUL};
  padding: 26px 24px 52px; text-align: center; color: #fff; position: relative;
`;

const Eyebrow = styled.div`
  font-size: 11px; font-weight: 600; letter-spacing: 1.4px;
  text-transform: uppercase; opacity: 0.75;
`;

const AvatarGroup = styled.div`
  position: absolute; left: 50%; bottom: -44px; transform: translateX(-50%);
  display: flex; align-items: center;
`;

const Avatar = styled.img<{ topo?: boolean }>`
  width: ${p => (p.topo ? 84 : 74)}px;
  height: ${p => (p.topo ? 84 : 74)}px;
  border-radius: 50%; object-fit: cover; object-position: center;
  border: 3px solid #fff; background: #fff;
  box-shadow: 0 6px 16px rgba(10, 22, 40, 0.22);
  position: relative;
  z-index: ${p => (p.topo ? 2 : 1)};
  &:not(:first-child) { margin-left: -18px; }
`;

const Body = styled.div`padding: 60px 26px 24px; text-align: center;`;

const Titulo = styled.h3`margin: 0 0 8px; font-size: 21px; font-weight: 700; color: #0f2544; line-height: 1.3;`;
const Texto = styled.p`margin: 0 0 22px; font-size: 14px; line-height: 1.55; color: #5b6b7f;`;

const Botoes = styled.div`display: flex; flex-direction: column; gap: 10px; text-align: left;`;

const Botao = styled.button<{ variante: 'primario' | 'secundario' }>`
  display: flex; align-items: center; gap: 12px;
  width: 100%; padding: 13px 16px; border-radius: 10px;
  font-size: 14.5px; font-weight: 600; cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
  border: 1px solid ${p => (p.variante === 'primario' ? AZUL : '#d7dee8')};
  background: ${p => (p.variante === 'primario' ? AZUL : '#fff')};
  color: ${p => (p.variante === 'primario' ? '#fff' : '#2b3a4d')};
  &:hover { background: ${p => (p.variante === 'primario' ? '#183a6b' : '#f3f6fa')}; }
  &:disabled { opacity: 0.55; cursor: default; }

  svg { flex-shrink: 0; }
  span { flex: 1; }
`;

const BotaoConfirmar = styled.button`
  width: 100%; padding: 13px 16px; border-radius: 10px; border: none;
  font-size: 14.5px; font-weight: 600; cursor: pointer;
  background: ${AZUL}; color: #fff;
  transition: background 0.15s ease;
  &:hover { background: #183a6b; }
`;

const BotaoWhats = styled.a`
  display: flex; align-items: center; justify-content: center; gap: 10px;
  width: 100%; padding: 13px 16px; border-radius: 10px; border: none;
  font-size: 14.5px; font-weight: 600; cursor: pointer; text-decoration: none;
  background: #25D366; color: #fff;
  transition: background 0.15s ease;
  &:hover { background: #1ebe5b; }
  svg { flex-shrink: 0; }
`;

const Fechar = styled.button`
  position: absolute; top: 12px; right: 14px; z-index: 2;
  background: rgba(255, 255, 255, 0.18); border: none; color: #fff;
  width: 28px; height: 28px; border-radius: 50%; font-size: 18px; line-height: 1; cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  transition: background 0.15s ease;
  &:hover { background: rgba(255, 255, 255, 0.32); }
`;

const IconeCalendario = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="18" rx="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" />
  </svg>
);
const IconeCheck = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" /><polyline points="22 4 12 14.01 9 11.01" />
  </svg>
);
const IconeDispensar = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" /><line x1="8" y1="12" x2="16" y2="12" />
  </svg>
);
const IconeWhatsApp = () => (
  <svg width="19" height="19" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38c1.45.79 3.08 1.21 4.79 1.21h.01c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.82 9.82 0 0 0 12.04 2zm0 1.67c2.2 0 4.27.86 5.82 2.42a8.19 8.19 0 0 1 2.42 5.82c0 4.54-3.7 8.24-8.25 8.24-1.52 0-3.01-.41-4.3-1.19l-.31-.18-3.12.82.83-3.04-.2-.32a8.2 8.2 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.25-8.24zm4.52 10.36c-.25-.12-1.47-.72-1.69-.81-.23-.08-.39-.12-.56.13-.16.25-.64.81-.79.97-.14.17-.29.19-.54.06-.25-.12-1.05-.39-1.99-1.23-.74-.66-1.23-1.47-1.38-1.72-.14-.25-.02-.38.11-.51.11-.11.25-.29.37-.43.13-.14.17-.25.25-.41.08-.17.04-.31-.02-.43-.06-.12-.56-1.34-.76-1.84-.2-.48-.4-.42-.56-.43-.14-.01-.31-.01-.48-.01-.17 0-.43.06-.66.31-.23.25-.87.85-.87 2.07 0 1.22.89 2.4 1.01 2.57.12.17 1.75 2.67 4.23 3.74.59.26 1.05.41 1.41.52.59.19 1.13.16 1.56.1.48-.07 1.47-.6 1.68-1.18.21-.58.21-1.07.14-1.18-.06-.11-.22-.17-.47-.29z" />
  </svg>
);

type Resultado = StatusTreinamento | null;

// Telas do fluxo iniciado pelo botão "Quero um treinamento" (ramificado pelo rastro do CRM).
type Tela = 'menu' | 'naoTeve' | 'emAndamento' | 'jaTeve' | 'jaTeveSim' | 'jaTeveNao';

// "há quanto tempo" desde o último pós-venda finalizado (posvenda_dias do CRM). null => não exibe.
const textoTempoPosVenda = (dias: number | null | undefined): string | null => {
  if (dias == null || dias < 0) return null;
  if (dias === 0) return 'hoje';
  if (dias === 1) return 'há 1 dia';
  if (dias < 30) return `há ${dias} dias`;
  const meses = Math.floor(dias / 30);
  if (meses < 12) return meses === 1 ? 'há cerca de 1 mês' : `há cerca de ${meses} meses`;
  // Deriva anos dos meses (não de dias/365) para não cair em "0 anos" na faixa 360–364 dias,
  // onde meses já é 12 mas dias/365 ainda arredonda para 0.
  const anos = Math.floor(meses / 12);
  return anos === 1 ? 'há cerca de 1 ano' : `há cerca de ${anos} anos`;
};

const CONFIRMACOES: Record<StatusTreinamento, { titulo: string; texto: string }> = {
  Solicitado: {
    titulo: 'Pedido recebido',
    texto: 'Recebemos sua solicitação. Nosso time de pós-venda vai entrar em contato para agendar o seu treinamento ao vivo.',
  },
  JaTeve: {
    titulo: 'Perfeito',
    texto: 'Que bom que você já participou do treinamento. Conte com a nossa equipe sempre que precisar.',
  },
  NaoPrecisa: {
    titulo: 'Tudo certo',
    texto: 'Sem problemas. Se mudar de ideia, o treinamento ao vivo estará sempre à sua disposição.',
  },
};

export default function ModalTreinamentoPosVenda() {
  const token = useAppSelector((state: any) => state.token);
  const [visivel, setVisivel] = useState(false);
  const [enviando, setEnviando] = useState(false);
  const [resultado, setResultado] = useState<Resultado>(null);
  const [tela, setTela] = useState<Tela>('menu');
  const [posvendaDias, setPosvendaDias] = useState<number | null>(null);

  useEffect(() => {
    if (!token) return;
    if (sessionStorage.getItem(SESSION_ADIADO) === 'true') return;
    // Exibir apenas para CLIENTE ATIVO (plano pago): esconder para plano gratuito e período de teste.
    if (ehPlanoGratuito(token) || estaEmPeriodoDeTeste(token)) return;
    try {
      if (obterIdTenent(token) === ADMIN_EMPRESA_ID) return;
    } catch { return; }

    let cancelado = false;
    let intervalo: ReturnType<typeof setInterval> | null = null;
    let timeoutId: ReturnType<typeof setTimeout> | null = null;
    let tentativas = 0;

    obterStatusTreinamentoPosVenda()
      .then((res) => {
        if (cancelado || res.data?.respondido) return;

        const tentarMostrar = (): boolean => {
          tentativas += 1;
          const outroModalAberto = !!document.querySelector('.modal.show, #pesquisa-overlay');
          if (!outroModalAberto || tentativas > 20) {
            setVisivel(true);
            if (intervalo) { clearInterval(intervalo); intervalo = null; }
            return true;
          }
          return false;
        };

        timeoutId = setTimeout(() => {
          if (cancelado) return;
          const mostrado = tentarMostrar();
          if (!cancelado && !mostrado && intervalo === null) {
            intervalo = setInterval(tentarMostrar, 1500);
          }
        }, 4000);
      })
      .catch(() => { /* silencioso: falha de rede não deve travar a Home */ });

    return () => {
      cancelado = true;
      if (timeoutId !== null) clearTimeout(timeoutId);
      if (intervalo) clearInterval(intervalo);
    };
  }, [token]);

  const responder = async (status: StatusTreinamento) => {
    setEnviando(true);
    try {
      await responderTreinamentoPosVenda(status);
    } catch { /* mesmo com erro, encerra o card para o usuário */ }
    setEnviando(false);
    setResultado(status);
  };

  // Botão "Quero um treinamento": consulta o rastro no CRM e direciona conforme o estágio.
  const solicitarTreinamento = async () => {
    setEnviando(true);
    // Estágio resolvido pelo rastro do CRM; define para onde direcionar E qual rótulo gravar.
    // Grava só depois de saber o estágio: um cliente que já teve treinamento não pode ser
    // rotulado como "Solicitou" para o pós-venda (idempotente, o card não reaparece).
    let statusRegistrar: StatusTreinamento = 'Solicitado';
    try {
      const { data } = await obterRastroPosVenda();
      setPosvendaDias(data.posvendaDias ?? null);
      // Direciona pelo estágio MAIS ALTO atingido (os booleanos não são monotônicos:
      // o CRM pode retornar posvendaFinalizado=true sem reuniaoMarcada/Concluida).
      // Estágio 3 (pós-venda finalizado) e 2 (reunião concluída) => já teve treinamento;
      // estágio 1 (reunião marcada, ainda não concluída) => em andamento; nada => encaminha.
      if (data.posvendaFinalizado || data.reuniaoConcluida) {
        setTela('jaTeve');
        statusRegistrar = 'JaTeve';
      } else if (data.reuniaoMarcada) {
        setTela('emAndamento');
        // Reunião já marcada: o cliente já está na esteira de treinamento. Não pode ser
        // rotulado como "Solicitou" para o pós-venda (senão o time reabre um pedido que já
        // está em andamento). Registra como "JaTeve" para sair da fila de novas solicitações.
        statusRegistrar = 'JaTeve';
      } else {
        setTela('naoTeve');
      }
    } catch {
      // Falha na consulta ao CRM: fallback seguro, encaminha para o pós-venda.
      setTela('naoTeve');
    }
    // Registra o engajamento (idempotente) para o card não reaparecer e o pós-venda ter o rastro.
    responderTreinamentoPosVenda(statusRegistrar).catch(() => { /* silencioso */ });
    setEnviando(false);
  };

  const fechar = () => {
    if (!resultado) sessionStorage.setItem(SESSION_ADIADO, 'true');
    setVisivel(false);
  };

  if (!visivel) return null;

  const primeiroNome = (() => {
    try {
      const raw = (obterNomeUsuario(token) || '').split(' ')[0];
      return raw.charAt(0).toUpperCase() + raw.slice(1).toLowerCase();
    } catch { return ''; }
  })();

  return (
    <Overlay data-modal-inicial onClick={fechar}>
      <Card onClick={(e) => e.stopPropagation()}>
        <Fechar onClick={fechar} aria-label="Fechar">×</Fechar>
        <Header>
          <Eyebrow>Sucesso do Cliente</Eyebrow>
          <AvatarGroup>
            <Avatar src={avatarWhats} alt="Especialista da equipe" />
            <Avatar src={avatar} topo alt="Especialista de treinamento" />
            <Avatar src={avatarTres} alt="Especialista da equipe" />
          </AvatarGroup>
        </Header>
        <Body>
          {resultado ? (
            <>
              <Titulo>{CONFIRMACOES[resultado].titulo}</Titulo>
              <Texto>{CONFIRMACOES[resultado].texto}</Texto>
              <BotaoConfirmar onClick={fechar}>Fechar</BotaoConfirmar>
            </>
          ) : tela === 'naoTeve' ? (
            <>
              <Titulo>Vamos te encaminhar para o pós-venda</Titulo>
              <Texto>
                Nossa equipe de pós-venda vai te ajudar a agendar o seu treinamento ao vivo.
                Fale com a gente agora pelo WhatsApp.
              </Texto>
              <BotaoWhats
                href={linkWhats(WHATS_POSVENDA, 'Olá! Quero agendar meu treinamento do LocaSmartPro.')}
                target="_blank" rel="noopener noreferrer" onClick={fechar}
              >
                <IconeWhatsApp /> Falar com o pós-venda
              </BotaoWhats>
            </>
          ) : tela === 'emAndamento' ? (
            <>
              <Titulo>Seu treinamento já está em andamento</Titulo>
              <Texto>
                Nosso time de pós-venda já está cuidando do seu treinamento. Se você está com
                alguma dificuldade agora, fale com o nosso suporte.
              </Texto>
              <BotaoWhats
                href={linkWhats(WHATS_SUPORTE, 'Olá! Meu treinamento do LocaSmartPro está em andamento e preciso de ajuda.')}
                target="_blank" rel="noopener noreferrer" onClick={fechar}
              >
                <IconeWhatsApp /> Falar com o suporte
              </BotaoWhats>
            </>
          ) : tela === 'jaTeve' ? (
            <>
              <Titulo>Você já participou de um treinamento</Titulo>
              <Texto>
                Notamos que você já teve o seu treinamento com a gente
                {textoTempoPosVenda(posvendaDias) ? ` (${textoTempoPosVenda(posvendaDias)})` : ''}.
                Está com alguma outra dificuldade?
              </Texto>
              <Botoes>
                <Botao variante="primario" onClick={() => setTela('jaTeveSim')}>
                  <IconeCheck /><span>Sim, preciso de ajuda</span>
                </Botao>
                <Botao variante="secundario" onClick={() => setTela('jaTeveNao')}>
                  <IconeDispensar /><span>Não, está tudo certo</span>
                </Botao>
              </Botoes>
            </>
          ) : tela === 'jaTeveSim' ? (
            <>
              <Titulo>Vamos te ajudar</Titulo>
              <Texto>
                Fale com o nosso suporte pelo WhatsApp e conte o que está acontecendo. Vamos
                resolver junto com você.
              </Texto>
              <BotaoWhats
                href={linkWhats(WHATS_SUPORTE, 'Olá! Já fiz meu treinamento do LocaSmartPro e estou com uma dificuldade.')}
                target="_blank" rel="noopener noreferrer" onClick={fechar}
              >
                <IconeWhatsApp /> Falar com o suporte
              </BotaoWhats>
            </>
          ) : tela === 'jaTeveNao' ? (
            <>
              <Titulo>Perfeito!</Titulo>
              <Texto>Estamos à disposição sempre que precisar. Bons negócios!</Texto>
              <BotaoConfirmar onClick={fechar}>Fechar</BotaoConfirmar>
            </>
          ) : (
            <>
              <Titulo>
                {primeiroNome ? `${primeiroNome}, acelere seus resultados` : 'Acelere seus resultados'}
              </Titulo>
              <Texto>
                Tenha um treinamento ao vivo com nossos especialistas para ajudar você a dominar o LocaSmartPro.
              </Texto>
              <Botoes>
                <Botao variante="primario" disabled={enviando} onClick={solicitarTreinamento}>
                  <IconeCalendario /><span>{enviando ? 'Consultando...' : 'Quero um treinamento'}</span>
                </Botao>
                <Botao variante="secundario" disabled={enviando} onClick={() => responder('JaTeve')}>
                  <IconeCheck /><span>Já participei de um treinamento</span>
                </Botao>
                <Botao variante="secundario" disabled={enviando} onClick={() => responder('NaoPrecisa')}>
                  <IconeDispensar /><span>Não preciso no momento</span>
                </Botao>
              </Botoes>
            </>
          )}
        </Body>
      </Card>
    </Overlay>
  );
}
